import { Box } from "@chakra-ui/react";
const EmptyCard = () => {
  return <Box p={4} h={"12.5rem"} minW={"15rem"} w={"full"} />;
};

export default EmptyCard;
